import {
  Alert,
  Avatar,
  BordersStyles,
  Box,
  Button,
  StatusLabel,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'
import { DocumentsUploadProcessOperationItemFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface Props {
  employeeAssigmentOperation: DocumentsUploadProcessOperationItemFragment
  isMerged?: boolean
  onRemoveEmployee: () => void
}

const EmployeeAssigned = ({
  employeeAssigmentOperation,
  isMerged = false,
  onRemoveEmployee,
}: Props) => {
  const [openTooltip, toggleTooltip] = useToggle(false)
  const isAutoAssigned = !employeeAssigmentOperation?.accessId
  const border: BordersStyles = {
    bottom: {
      width: 's1',
      style: 'solid',
      color: 'grey400',
    },
  }

  return (
    <Box gap="s12" paddingX="s12" paddingY="s16" background="grey100" border={border}>
      <Box flexDirection="row" gap="s12">
        <Box flexDirection="row">
          <Avatar
            url={buildUrl(employeeAssigmentOperation?.employee?.access?.avatar)}
            label={employeeAssigmentOperation?.employee?.fullName || ''}
          />
        </Box>
        <Box flexDirection="column" gap="s4">
          <Text size="300" weight="medium" color="textPrimary">
            {employeeAssigmentOperation?.employee?.fullName}
          </Text>
          <Text size="100" weight="medium" color="textPrimary">
            {employeeAssigmentOperation?.employee?.referenceContract?.jobTitle || '-'}
          </Text>
          {isAutoAssigned && (
            <Tooltip.Alt
              attachment="middle left"
              open={openTooltip}
              toggle={toggleTooltip}
              size="big"
              label={i18n.t('split_documents.workflow_payslips.employee_assigned.assigned_by', {
                name: employeeAssigmentOperation?.employee?.firstName,
              })}
            >
              <Box cursor="pointer">
                <StatusLabel type="positive">
                  {i18n.t('split_documents.workflow_payslips.employee_assigned.statuses.assigned')}
                </StatusLabel>
              </Box>
            </Tooltip.Alt>
          )}
          {!isAutoAssigned && (
            <StatusLabel type="neutral">
              {i18n.t(
                'split_documents.workflow_payslips.employee_assigned.statuses.manually_assigned'
              )}
            </StatusLabel>
          )}
        </Box>
      </Box>
      {isMerged && (
        <Alert color="info">
          {i18n.t('split_documents.workflow_payslips.employee_assigned.merged')}
        </Alert>
      )}
      <Box
        alignItems="flexEnd"
        style={{ width: '100%' }}
        background="grey100"
        gap="s4"
        justifyContent="spaceBetween"
      >
        <Box paddingLeft="s8">
          <Box flexDirection="row" gap="s8">
            <Button type="secondary" onClick={onRemoveEmployee}>
              {i18n.t('split_documents.workflow_payslips.employee_assigned.change')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmployeeAssigned
